// extracted by mini-css-extract-plugin
export default {"modal":"BlockImageCropModal_modal__u92k5","cropContainer":"BlockImageCropModal_cropContainer__I5hUv"};